<template>
  <div class="field-wrapper">
    <div class="content">
      <div class="title">
        <i class="yuzu-icon yuzu-ai"></i>
        <p>{{ $t("app.campaign.newPage.aiStep2.title") }}</p>
      </div>
      <div>
        <span class="yuzuai">{{ $t('app.campaign.newPage.yuzuAI') }}&nbsp;</span>
        <span>{{ $t("app.campaign.newPage.aiStep2.analyzing") }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.field-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  //align-items: center;
  width: 100%;

  .yuzu-icon {
    display: block;
    font-size: 32px;
    width: 20px;
    height: 20px;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .title {
      color: var(--secondary-color);
      font-family: $bioSans;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      display: flex;
      gap: 8px;
    }
  }
}
</style>

<script setup lang="ts">

</script>